export default {
  nav_spreadsheet: 'CSSBuy Spreadsheet',
  nav_home: 'Startseite',
  nav_shopping_guide: 'Einkaufsführer',
  nav_reviews: 'Reviews',
  nav_shipping: 'Versand',
  nav_coupons: 'Gutscheine',
  nav_guides: 'Anleitungen',
  nav_safety: 'Sicherheit',
  nav_warehouse: 'Lager',
  nav_blog: 'Blog',
  nav_about: 'Über Uns',
  nav_contact: 'Kontakt',
  nav_faq: 'FAQ',
  hero_title: 'CSSBuy Spreadsheet 2026: Produkte, Links und Anleitungen entdecken',
  hero_subtitle: 'Eine unabhängige Ressource für CSSBuy Spreadsheet mit Produktrecherche, Kategorieleitfäden, QC-Erklärungen, Versandinformationen und praktischen Kauftipps.',
  hero_cta_primary: 'CSSBuy Spreadsheet ansehen',
  hero_cta_secondary: 'Anleitungen ansehen',
  trust_badge: 'Unabhängige Ressource · Aktualisierter Inhalt · Praktische Anleitungen · PT / EN / DE',
  what_is_title: 'Was ist ein CSSBuy Spreadsheet?',
  what_is_p1: 'Ein CSSBuy Spreadsheet ist eine organisierte Möglichkeit, Produkte, Links, Kategorien und nützliche Informationen zu sammeln, um die Recherche zu erleichtern. Es hilft dabei, Informationen schneller zu finden, aber jedes Element sollte vor dem Kauf verifiziert werden.',
  what_is_p2: 'Ein Spreadsheet garantiert keine Qualität, keinen Preis, keinen Lagerbestand, keine Verfügbarkeit oder Lieferung. Bestätigen Sie immer die aktuellen Informationen, bevor Sie eine Bestellung abschließen.',
  what_is_cta: 'CSSBuy Spreadsheet ansehen',
  how_it_works_title: 'Wie man das CSSBuy Spreadsheet verwendet',
  step_1: 'Wählen Sie eine Kategorie',
  step_2: 'Finden Sie ein Produkt oder einen Link',
  step_3: 'Überprüfen Sie Preis und Informationen',
  step_4: 'Verifizieren Sie QC, Größe und Details',
  step_5: 'Vergleichen Sie Alternativen',
  step_6: 'Bestätigen Sie die aktuellen Bedingungen',
  step_7: 'Fahren Sie auf der Hauptseite fort',
  how_cta: 'Jetzt starten',
  categories_title: 'Kategorien erkunden',
  categories_subtitle: 'Durchsuchen Sie Produktkategorien und finden Sie, was Sie brauchen',
  guides_title: 'Beliebteste CSSBuy-Anleitungen',
  guides_subtitle: 'Detaillierte Anleitungen, um CSSBuy sicher zu navigieren',
  comparison_title: 'CSSBuy Spreadsheet vs. traditionelle Recherche',
  comparison_feature: 'Funktion',
  comparison_spreadsheet: 'CSSBuy Spreadsheet',
  comparison_traditional: 'Traditionelle Recherche',
  comparison_org: 'Organisation nach Kategorie',
  comparison_links: 'Links gesammelt',
  comparison_guides: 'Spezifische Anleitungen',
  comparison_compare: 'Vergleich',
  comparison_intent: 'Intent-basierte Recherche',
  comparison_yes: 'Ja',
  comparison_no: 'Nein',
  comparison_limited: 'Begrenzt',
  comparison_easy: 'Einfach',
  comparison_manual: 'Manuell',
  safety_title: 'Sicherer recherchieren',
  safety_tip_1: 'Überprüfen Sie Domain und Link vor dem Zugriff',
  safety_tip_2: 'Bestätigen Sie Produktinformationen',
  safety_tip_3: 'Überprüfen Sie Größe und Optionen',
  safety_tip_4: 'Lesen Sie QC-Informationen',
  safety_tip_5: 'Überprüfen Sie Versandkosten',
  safety_tip_6: 'Bestätigen Sie aktuelle Gutscheine',
  safety_tip_7: 'Teilen Sie niemals Passwörter',
  safety_tip_8: 'Senden Sie niemals Finanzdaten an unbekannte Seiten',
  safety_cta: 'Sicherheitsleitfaden lesen',
  articles_title: 'Neueste CSSBuy-Anleitungen',
  articles_subtitle: 'Detaillierte Artikel und Anleitungen für sicheres Einkaufen',
  read_guide: 'Anleitung lesen',
  reading_time: 'Min. Lesen',
  updated: 'Aktualisiert',
  faq_title: 'Häufig gestellte Fragen',
  faq_subtitle: 'Häufige Fragen zum CSSBuy Spreadsheet',
  final_cta_title: 'Bereit loszulegen?',
  final_cta_subtitle: 'Erkunden Sie das CSSBuy Spreadsheet und setzen Sie Ihre Recherche auf unserer Hauptseite fort.',
  final_cta_button: 'CSSBuy Spreadsheet erkunden',
  main_cta_button: 'Jetzt kaufen',
  footer_resources: 'Ressourcen',
  footer_company: 'Unternehmen',
  footer_disclaimer: 'Unabhängige Informationsressource. Nicht die offizielle CSSBuy-Website. Externe Informationen können sich ändern.',
  lang_pt: 'PT',
  lang_en: 'EN',
  lang_de: 'DE',
  editorial_policy: 'Redaktionsrichtlinien',
  disclaimer: 'Haftungsausschluss',
  privacy: 'Datenschutz',
  about_us: 'Über Uns',
  article_author: 'Redaktionsteam',
  article_related: 'Verwandte Artikel',
  article_toc: 'Inhaltsverzeichnis',
  article_quick_answer: 'Schnelle Antwort',
  article_pros: 'Vorteile',
  article_cons: 'Nachteile',
  article_checklist: 'Checkliste',
  breadcrumb_home: 'Startseite',
  breadcrumb_guides: 'Anleitungen',
  category_select: 'Kategorie auswählen',
  category_dropdown_label: 'Kategorien durchsuchen',
  home_seo_title: 'CSSBuy Spreadsheet 2026: Links, Anleitungen und Produkte',
  home_seo_description: 'Erkunden Sie das CSSBuy Spreadsheet 2026 mit Links, Kategorien, Anleitungen, QC, Versand, Gutscheinen und praktischen Informationen für sichere Produktrecherche.',
  home_seo_keywords: 'CSSBuy Spreadsheet, CSSBuy Links, CSSBuy Anleitung, CSSBuy QC, CSSBuy Versand, CSSBuy Gutschein',
  back_to_home: 'Zurück zur Startseite',
  learn_more: 'Mehr erfahren',
  view_all: 'Alle ansehen',
  search: 'Suchen',
  minutes_read: 'Min. Lesen',
  share: 'Teilen',
  copy_link: 'Link kopieren',
  copied: 'Kopiert!',
};